import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';
import Joi from 'joi-browser';
import EventMg from '../utilities/EventManager';
import dialogLoader from '../utilities/dialogLoader';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import regex from '../utilities/validateRegex';
import { validationByJoi } from '../utilities/commonValidation';
import ImageUtility from '../utilities/imageUtility';
import { PartnerNaviList } from '../components/list/PartnerNaviList';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';

import {
  HEADER_CONSTANTS, // ヘッダータイトル
  maxiileSize, // 画像ファイルサイズ
  DIALOG_STATUS,
  JOINING_FLAG,
  ONE_MASTER_FLAG,
} from '../utilities/constants';

import { PartnerCompanyForm } from '../components/forms/PartnerCompany'; // フォーム
import { CompanyService } from '../services/Companies';
import { messageUtility } from '../utilities/messageUtility';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { isApiFlagOn } from '../utilities/commonUtil';
import {
  isNullOrEmpty,
  safariOnIosCheck,
  deleteControlCode,
} from '../utilities/stringUtil';
import { onceAsyncRequest } from '../utilities/commonUtil';
import { getPartnerCompanyInfo } from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { FormInformationDialog } from '../components/FormInformationDialog';
import ConfirmationSafetyDocItemDialog from '../components/worker/dialog/ConfirmationSafetyDocItemDialog';
import Style from '../styles/componentStyle/worker/insuranceInfo/insuranceInfo.scss';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { CcusTitleBlock } from '../components/CcusFormComponent';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import WorkersApi from '../services/workers/WorkersApi';

const MY_EVENT = {
  LOAD_PARTNER_COMPANIES: 'load_partner_companies', // 一覧取得
};

/**
 * 協力会社 会社情報 編集 画面
 * 画面遷移
 *  1.  協力会社管理者 > 会社情報 > 基本情報 > 編集
 */
export class CompanyEdit extends React.Component {
  constructor(props) {
    super(props);

    this.selectedCompanyId = SessionStorageService.getItem(
      'sessionSelectedPartnerCompanyId'
    );

    this.state = {
      selectedCompanyName: '',
      // ユーザーロール
      roleId: LocalStorageService.getRoleId(),
      userId: LocalStorageService.getUserId(),
      ccusCompanyData: null,
      isCommonHojin: false,
      requiredInput: {
        // 必須入力項目
        columns: [
          'name',
          'kana',
          'juridical_personality_code',
          'postal_code',
          'prefectures_code_id',
          'city_name',
          'tel',
        ], // 必須項目名
        hasBranch: [], // 支店
        total: 0, // 必須総数
        count: 0, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      image: {
        // アップロード画像
        file: '', // バイナリ
        path: '', // 画像URL
        isSet: false, // 画像セットフラグ
      },
      formValues: {
        name: '', // 会社名
        kana: '', // 会社名かな
        juridical_personality_code: '', // 法人格
        company_number: '', // 法人番号
        postal_code: '', // 郵便番号
        prefectures_code_id: '', // 都道府県
        city_name: '', // 市区町村
        street_number: '', // 丁目・番地
        building_name: '', // 建物名・部屋番号
        tel: '', // 電話番号
        fax: '', // FAX
        common_partner_company_code: '', // 協力会社コード
        joining_flag: SessionStorageService.getPartnerCompanyJoiningFlag(),
        ccus_jigyousya_id: '', //ccus事業者id
        update_username: '', // 更新ユーザー
        updated_at: '', // 更新日時
        company_branch: {
          // 支店情報
          id: '', // 支店ID
          name: '', // 支店名
          kana: '', // 支店名かな
        },
        one_owner_flag: null,
        one_master_flag: 0,
      },
      dialogStatus: DIALOG_STATUS.disabled.id,
      confirmationModalSafetyDocItem: {
        // 安全書類項目用バリデート
        errorPropertyList: [],
      },
      passChecgeFlg: false,
      users: null,
      isLoading: false,
      ccusData: null,
      expirationCompany: {},
      isPartnerCompanyBranchExist: false,
      totalWorkers: null,
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.submit = this.submit.bind(this); // 会社登録
    this.validate = this.validate.bind(this); // バリデーション
    this.imageExists = this.imageExists.bind(this); // 画像判定

    // イベント登録
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBackDialog.bind(this), // 閉じる
      },
      form: {
        setCcusCompanyData: this.setCcusCompanyData.bind(this),
        setCompanyByCcus: this.setCompanyByCcus.bind(this),
        // フォーム関連
        setCompany: this.setCompany.bind(this), // 会社情報入力
        validate: this.validate.bind(this), // フォーカスアウト時のバリデーション
        setValue: this.setValue.bind(this), // 値入力
        setImage: this.setImage.bind(this), // 画像アップ
        update: this.update.bind(this), // 更新
        deleteImage: this.deleteImage.bind(this), // 画像削除
      },
    };

    // 会社情報バリデーションパターン
    this.companySchema = {
      name: Joi.string()
        .required()
        .max(255), // 会社名
      kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(512), // 会社名かな
      juridical_personality_code: Joi.number().required(), // 法人格
      postal_code: Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .required(), // 郵便番号
      prefectures_code_id: Joi.number().required(), // 都道府県
      city_name: Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .required()
        .max(512), // 市区町村
      street_number: Joi.string()
        .max(512)
        .allow(null, ''), // 丁目・番地
      building_name: Joi.string()
        .max(512)
        .allow(null, ''), // 建物名・部屋番号等
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required(), // 電話番号
      fax: Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        // FAXは必須ではないのに空文字でバリデーションエラーが出るので「--」も許可
        .allow(null, '', '--'), // FAX
      common_partner_company_code: Joi.string()
        .max(16)
        .allow(null, ''), // 協力会社コード
      ccus_jigyousya_id: Joi.number().allow(null, ''),
      joining_flag: Joi.number().allow(null, ''),
    };

    // 支店情報バリデーションパターン
    this.partnerSchema = {
      id: Joi.number(), // 支店ID
      name: Joi.string().allow(null, ''), // 支店名
      kana: Joi.string().allow(null, ''), // 支店ふりがな
      branch_name: Joi.allow(null, ''),
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        clear: () => {
          _masterSlideLoader.show('CompanyPreview', {
            state: { id: this.selectedCompanyId },
          });
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };

    // 類似協力会社ダイアログ
    this.SimilarPartnerCompany = {
      callback: {
        data: [], // 類似協力会社
        submit: () => {
          this.submit();
        },
      },
    };
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    this.setPartnerCompanyBranchExist();
    this.getCompany();
    this.getExpiration();
  }

  getCompany = async () => {
    this.setState({
      isLoading: true,
    });
    const {
      result,
      company,
      companyName,
      icon_image_url,
      users,
      company_branch,
    } = await getPartnerCompanyInfo(this.selectedCompanyId);

    if (!result) {
      this.setState({
        isLoading: false,
      });
      return;
    }

    this.setState({
      selectedCompanyName: companyName,
      users,
      isLoading: false,
    });
    this.initForm(company, company_branch, icon_image_url);
  };

  setPartnerCompanyBranchExist = async () => {
    const params = {
      block_flags: [false],
      offset: 0,
      limit: 1,
      is_limit: 1,
    };
    const response = await PartnerCompanyBranchService.partnerCompanyBranchList(
      this.selectedCompanyId,
      params
    );
    if (response.result) {
      const branches = _.get(
        response,
        'data.entities.partner_company_branches'
      );
      this.setState({ isPartnerCompanyBranchExist: !_.isEmpty(branches) });
    }
  };

  /**
   * フォーム生成
   * @param company {object} 会社情報
   * @param company_branch {object} 支店情報
   * @param images
   */
  initForm(company, company_branch, images) {
    const formValues = _.cloneDeep(this.state.formValues);
    const image = _.cloneDeep(this.state.image);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const isCommonHojin = this.isCommonHojin(company);

    // 会社情報
    _.each(company, (company_data, index) => {
      if (_.has(formValues, index)) {
        formValues[index] = _.defaultTo(company_data, '');
      }
    });

    // 支店情報
    _.each(company_branch, (company_branch_data, index) => {
      if (_.has(formValues.company_branch, index)) {
        formValues.company_branch[index] = company_branch_data
          ? `${company_branch_data}`
          : '';
      }
    });

    // 支店情報
    if (!_.isNaN(company_branch)) {
      formValues.company_branch.name = company_branch.name;
      formValues.company_branch.kana = company_branch.kana;
    }

    if (!String(formValues.juridical_personality_code) || !isCommonHojin) {
      // 法人格
      _.pull(requiredInput.columns, 'juridical_personality_code');
    }

    if (_.isEqual(company.one_master_flag, ONE_MASTER_FLAG.personal.id)) {
      requiredInput.columns = [...requiredInput.columns, 'one_owner_flag'];
      this.companySchema.one_owner_flag = Joi.number().required();
    }

    image.path = images;
    this.setState(
      {
        image,
        formValues,
        isCommonHojin,
        requiredInput,
      },
      () => {
        this.validate();
        this.setTotalWorkers();
      }
    );
  }

  isCommonHojin(company) {
    const { joining_flag, one_master_flag } = company;
    if (
      joining_flag === 1 &&
      (one_master_flag === null || one_master_flag === 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ccus
   */
  setCcusCompanyData = ({ ccusCompanyData }) => {
    const state = _.cloneDeep(this.state);
    state.ccusCompanyData = ccusCompanyData;
    state.formValues.ccus_jigyousya_id = _.has(ccusCompanyData, `ccus_id`)
      ? ccusCompanyData.ccus_id
      : null;
    this.setState(state);
  };

  createCompanyStateDataByCcus = (state, name, section, value) => {
    if (section === 'company') {
      state.formValues[name] = value;
    } else {
      state.formValues[section][name] = value;
    }

    const schema = this.changeSchema(state.formValues);
    state.validate = validationByJoi(
      Joi.object().keys(schema),
      state.formValues
    );

    if (
      state.validate.status === false &&
      _.includes(_.keys(state.validate.messages), 'company_branch')
    ) {
      _.forEach(state.validate.messages.company_branch, function(value, key) {
        const newKeyName = `company_branch_${key}`;
        state.validate.messages[newKeyName] = value;
      });
    }
    return state;
  };

  /**
   * CCUSの情報に変更
   */
  setCompanyByCcus = (name, section, value) => {
    let state = _.cloneDeep(this.state);
    state = this.createCompanyStateDataByCcus(state, name, section, value);
    this.setState(state, () => this.validate());
  };

  /**
   * 全てのccus情報をフォームに代入する
   */
  setAllDataToForm = data => {
    let state = _.cloneDeep(this.state);
    _.each(data, (item, key) => {
      if (key === 'ccus_id') {
        state.formValues.ccus_jigyousya_id = item;
      } else {
        _.each(item, (_item, _key) => {
          if (!isNullOrEmpty(_item)) {
            state = this.createCompanyStateDataByCcus(state, _key, key, _item);
          }
        });
      }
    });
    this.setState(state, () => this.validate());
  };

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 会社情報入力
   */
  setCompany = e => {
    const formValues = _.cloneDeep(this.state.formValues);
    const event = _.cloneDeep(e);
    const name = event.target.name;
    let value = deleteControlCode(event.target.value);
    if (name === 'one_owner_flag') {
      value = Number(value);
    }
    formValues[name] = value;
    this.setState({ formValues }, () => {
      if (event.target.name === 'one_owner_flag') {
        this.validate(event);
      } else {
        this.validate();
      }
    });
  };

  setUsers = users => {
    this.setState({ users, passChecgeFlg: true });
  };

  /**
   * 値入力
   * @param name {string}
   * @param value {any}
   */
  setValue = (name, value, category) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const validate = _.cloneDeep(this.state.validate);

    value = deleteControlCode(value);

    if (category === 'company_branch') {
      formValues.company_branch[name] = value;
    } else {
      formValues[name] = value;
    }

    this.setState(
      {
        formValues,
        validate,
      },
      () => {
        this.validate();
      }
    );
  };

  /**
   * 画像アップロード
   */
  setImage = e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    const validate = this.state.validate;
    const image = _.cloneDeep(this.state.image);
    if (files[0].size > maxiileSize) {
      validate.messages.image = messageUtility.getMessage('E-000-011');
      image.isSet = false;
      image.path = '';
      image.file = '';
    } else {
      const url = createObjectURL(files[0]);
      this.imageExists(url, e.target, async (loaded, target) => {
        const type = await ImageUtility.fileTypeCheck(target.files[0]);
        if (loaded && type) {
          image.path = url;
          image.file = target.files[0];
          image.isSet = true;
          validate.messages.image = '';
        } else {
          validate.messages.image = messageUtility.getMessage('E-000-012');
          image.isSet = false;
          image.path = '';
          image.file = '';
        }
        this.setState({
          validate,
          image,
        });
      });
    }
    this.setState({
      validate,
      image,
    });
  };

  /**
   * 画像判定
   * @param url {string}
   * @param target
   * @param callback
   */
  imageExists(url, target, callback) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      callback(true, target);
    };
    img.onerror = () => {
      callback(false);
    };
  }

  /**
   * 画像削除
   */
  deleteImage = () => {
    const image = _.cloneDeep(this.state.image);
    image.path = '';
    image.file = '';
    image.isSet = true;
    this.setState({
      image,
    });
    // onChangeイベントを感知
    document.getElementById('file-company-branch-image').value = '';
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  validate(e, targetName) {
    const values = _.cloneDeep(this.state.formValues);
    const validate = _.cloneDeep(this.state.validate);

    const schema = this.changeSchema(values);
    const result = validationByJoi(Joi.object().keys(schema), values);
    const available = result.status;
    if (!available && e) {
      // フォーカスアウトした要素名
      const id = e.target.id;
      const name = _.isEmpty(targetName) ? e.target.name : targetName;
      const errors = result.messages;
      // 支店=false,会社=true
      let company_flg = true;
      if (id === 'company_branch_name' || id === 'company_branch_kana') {
        company_flg = false;
      }
      if (_.has(errors, name) && company_flg) {
        // 要素が本社情報なら
        validate.messages[name] = errors[name];
        validate.invalid = true;
      } else if (_.has(errors.company_branch, name) && !company_flg) {
        // 要素が支店情報なら
        validate.messages[`company_branch_${name}`] =
          errors.company_branch[name];
        validate.invalid = true;
      } else if (_.has(validate.messages, name) && company_flg) {
        delete validate.messages[name];
      } else if (
        _.has(validate.messages, `company_branch_${name}`) &&
        !company_flg
      ) {
        delete validate.messages[`company_branch_${name}`];
      }
    } else if (!available) {
      _.each(result.messages, (message, key) => {
        if (_.isObject(message)) {
          _.each(message, (value, index) => {
            validate.messages[`company_branch_${index}`] = value;
          });
        }
        validate.messages[key] = message;
      });
      validate.invalid = true;
    } else {
      validate.messages = {};
      validate.invalid = false;
    }
    this.setState({ validate }, () => {
      this.checkRequired();
    });
    return available;
  }

  changeSchema(values) {
    // 会社情報バリデーションパターン
    const companySchema = _.cloneDeep(this.companySchema);
    const juridicalCode = values.juridical_personality_code;

    if (!juridicalCode) {
      companySchema.juridical_personality_code = Joi.number().allow(null, '');
    }

    const partnerSchema = { ...this.partnerSchema };
    if (isApiFlagOn(values.joining_flag)) {
      // 支店非表示の場合
      partnerSchema.name = Joi.string().allow(null, '');
      partnerSchema.kana = Joi.string().allow(null, '');
    }

    // バリデーションパターン結合
    return {
      ...companySchema,
      company_branch: Joi.object(partnerSchema),
    };
  }

  delvalidate() {
    const validate = _.cloneDeep(this.state.validate);
    delete validate.messages.company_branch_name;
    delete validate.messages.company_branch_kana;
    validate.invalid = false;

    this.setState({ validate });
  }

  /**
   * 必須入力状況チェック
   */
  checkRequired() {
    const formValues = _.cloneDeep(this.state.formValues);
    // const validate = _.cloneDeep(this.state.validate);
    // 必須チェック
    const requiredInput = { ...this.state.requiredInput };
    const validate = { ...this.state.validate };
    let count = 0;

    let hasBranch = [...requiredInput.hasBranch];
    if (isApiFlagOn(formValues.joining_flag)) {
      // 支店非表示の場合
      hasBranch = _.pull(hasBranch, 'name', 'kana');
    }

    // 会社情報
    _.each(requiredInput.columns, column => {
      if (
        (formValues[column] || _.isEqual(column, 'one_owner_flag')) &&
        !validate.messages[column]
      ) {
        count += 1;
      }
    });
    // 支店情報
    _.each(hasBranch, column => {
      if (
        formValues.company_branch[column] &&
        !validate.messages[`company_branch_${column}`]
      ) {
        count += 1;
      }
    });
    requiredInput.count = count;
    requiredInput.total = _.size(requiredInput.columns) + _.size(hasBranch);
    this.setState({ requiredInput });
  }

  /**
   * 更新
   */
  update = () => {
    if (this.validate()) {
      // 協力会社の会社情報更新時、類似会社チェックはおこなわないようにする。 BLDE_V2-17697
      // this.validatePartnerCompany().then(valid => {
      //   if (valid) {
      //     this.submit();
      //   }
      // });
      const safetyValidateResult = this.safetyDocItemValidate();
      if (safetyValidateResult.status === false) {
        this.setSafetyDocErrorMessages(safetyValidateResult);
        this.onOpenSafetyDocItemErrorDialog();
      } else {
        this.submit();
      }
    }
  };

  /**
   * 類似会社チェック
   */
  validatePartnerCompany() {
    const values = _.cloneDeep(this.state.formValues);
    const param = {
      company_id: this.state.selected_partner_company_id,
      kana: values.kana,
      postal_code: values.postal_code,
      tel: values.tel,
    };
    return CompanyService.similarityCompany(param).then(response => {
      const companies = response.data.entities.companies;
      if (_.size(companies) > 1) {
        // 更新時は2社以上だった場合に重複確認
        dialogLoader.show(
          SimilarPartnerCompanyDialog,
          this.SimilarPartnerCompany,
          companies
        );
        return false;
      } else {
        return true;
      }
    });
  }

  /**
   * 登録
   */
  submit = onceAsyncRequest(async () => {
    const values = _.cloneDeep(this.state.formValues);
    values.users = _.cloneDeep(this.state.users);
    if (this.state.passChecgeFlg) {
      values.password_reset_notice_user = [];
      _.each(this.state.users, users => {
        const data = {};
        users.password_reset_notice_flag
          ? (data.password_reset_notice_flag = 1)
          : (data.password_reset_notice_flag = 0);
        data.user_id = users.id;
        values.password_reset_notice_user.push(data);
      });
    }

    const response = await CompanyService.update(
      this.selectedCompanyId,
      values
    );
    if (response.result !== true) {
      return this.showErrorUpdateDialog(_.get(response, 'data.message'));
    }

    // 画像セット
    if (this.state.image.isSet === true) {
      var formData = new FormData();
      formData.append('image', this.state.image.file);
      await CompanyService.upload_image(this.selectedCompanyId, formData);
    }
    dialogLoader.show(FormInformationDialog, {
      title: '会社情報 基本情報更新',
      message: '会社情報 基本情報の更新が完了しました。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: { id: this.selectedCompanyId },
        });
      },
    });
    EventMg.trigger(MY_EVENT.LOAD_COMPANY, this.selectedCompanyId);
  });

  onCloseSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
    });
  };
  onOpenSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id,
    });
  };

  isUseSafety = () => {
    return (
      this.state.formValues.joining_flag ===
      JOINING_FLAG.commonPartnerCompany.id
    );
  };

  /**
   * 安全書類項目に未入力がないかの確認
   * 安全書類項目は必須ではない
   */
  safetyDocItemValidate = () => {
    // 労務安全が使用できない場合は何もしない
    if (!this.isUseSafety()) {
      return {
        status: true,
      };
    }

    const values = Object.create(null);
    values.street_number = this.state.formValues.street_number;
    values.building_name = this.state.formValues.building_name;

    const validateSchema = Object.create(null);
    // 丁目・番地
    validateSchema.street_number = Joi.string().required();
    // 建物名・部屋番号等
    validateSchema.building_name = Joi.string().required();

    const result = validationByJoi(validateSchema, values);
    return result;
  };

  setSafetyDocErrorMessages = validateResult => {
    const errorMessages = this.createErrorMessageList(validateResult.messages);
    this.setState({
      confirmationModalSafetyDocItem: {
        errorPropertyList: errorMessages,
      },
    });
  };

  createErrorMessageList = messages => {
    const errorMessages = [];
    Object.keys(messages).forEach(key => {
      const errorPropertyMessage = this.getErrorPropertyMessageByNameKey(key);
      if (errorPropertyMessage !== '') {
        errorMessages.push(errorPropertyMessage);
      }
    });
    return errorMessages;
  };

  getErrorPropertyMessageByNameKey = nameKey => {
    switch (nameKey) {
      case 'street_number':
        return messageUtility.getMessage('I-000-188');
      case 'building_name':
        return '建物名・部屋番号等';
      default:
        return '';
    }
  };

  clearCcusId = () => {
    this.setState({ data: null });
    this.setCcusCompanyData({
      ccusCompanyData: null,
    });
  };

  setCcusData = ccusData => {
    this.setState({ ccusData });
  };

  showErrorUpdateDialog = message => {
    dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('E-001-402'),
      message,
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: { id: this.selectedCompanyId },
        });
      },
    });
  };

  setTotalWorkers = async () => {
    const response = await WorkersApi.list(this.selectedCompanyId, {
      offset: 0,
      limit: 2,
      include_blocked: 'false',
    });
    if (response.result) {
      this.setState({ totalWorkers: _.get(response, 'data.total') || 0 });
    }
  };

  render() {
    let masterSlideViewBodyHeight = 'calc(100vh - 84px)';
    // ios-safariだとツールバー分の高さがある為、考慮する
    // 後々ブラッシュアップが必要
    if (safariOnIosCheck()) {
      masterSlideViewBodyHeight = 'calc(100vh - 115px)';
    }

    const { selectedCompanyName, isLoading } = this.state;

    const title = `${selectedCompanyName} 会社情報`;

    return (
      <React.Fragment>
        <div
          id='slide-view'
          className='contruction-slide-view show CompanyEdit'
        >
          <Helmet>
            <title>
              {HEADER_CONSTANTS.title} - {title}
            </title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              title={title}
              loaded={!isLoading}
              loaderComponent={<ClipLoader size={20} color={'#EDB715'} />}
              onClose={() => this.events.dialog.goBack()}
            />
            <div
              className='contruction-slide-view__body'
              style={{ height: masterSlideViewBodyHeight }}
            >
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <PartnerNaviList
                    isSelectedBasicInfomation={true}
                    isEditable={true}
                    selectedPartnerCompanyId={this.selectedCompanyId}
                    expirationCompany={this.state.expirationCompany}
                  />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu'>
                    <span className='construction-detail-view__button'>
                      <button
                        className='btn--sub'
                        onClick={() => this.events.dialog.goBack()}
                      >
                        編集をやめる
                      </button>
                    </span>
                    <span className='construction-detail-view__button'>
                      <button
                        className={
                          this.state.validate.invalid
                            ? 'btn--effective btn--disabled'
                            : 'btn--effective'
                        }
                        onClick={() => this.events.form.update()}
                        disabled={this.state.validate.invalid}
                      >
                        更新
                      </button>
                    </span>
                    <span
                      className='construction-detail-view__button'
                      style={{
                        right: '120px',
                        color: '#E64E17',
                        fontSize: '12px',
                      }}
                    >
                      {this.state.validate.invalid
                        ? '入力エラーがあります。'
                        : ''}
                    </span>
                    <div className='contruction-detail-view__end-item'>
                      {`必須項目の入力数 ${this.state.requiredInput.count}/${
                        this.state.requiredInput.total
                      }`}
                    </div>
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
                    <FormList>
                      <FormListSubHeader
                        title='基本情報'
                        ccusComponent={
                          this.state.ccusCompanyData && (
                            <CcusTitleBlock
                              onClick={e => {
                                e.preventDefault();
                                this.setAllDataToForm(this.state.ccusData);
                              }}
                            />
                          )
                        }
                        noMarginTop={true}
                      />
                      <PartnerCompanyForm
                        roleId={this.state.roleId}
                        values={this.state.formValues}
                        users={this.state.users}
                        userCompany={this.selectedCompanyId}
                        events={this.events.form}
                        messages={this.state.validate.messages}
                        image={this.state.image.path}
                        ccusCompanyData={this.state.ccusCompanyData}
                        onUserSave={this.setUsers}
                        isCommonHojin={this.state.isCommonHojin}
                        isPartnerCompanyBranchExist={
                          this.state.isPartnerCompanyBranchExist
                        }
                        totalWorkers={this.state.totalWorkers}
                      />
                    </FormList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          rootClassName={Style.safetyDocItemErrorDialog}
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.submit();
            });
          }}
          onCancel={this.onCloseSafetyDocItemErrorDialog}
        />
      </React.Fragment>
    );
  }
}

/**
 * 類似協力会社
 */
class SimilarPartnerCompanyDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__body text-center'>
          {messageUtility.getMessage('I-000-012')}
        </div>
        <div className='dialog-md__body'>
          <div className='dialog-form__scroll'>
            {_.map(this.props.dialog.callback.data, (company, index) => (
              <div key={index}>
                <p>{company.name}</p>
                <p>{`〒${company.company_branch.postal_code} ${
                  company.company_branch.address
                }`}</p>
                <p>{`電話番号: ${company.company_branch.tel}`}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.submit();
            }}
          >
            登録する
          </button>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            キャンセル
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CompanyEdit.jsx